import { createIntl, createIntlCache, type IntlConfig } from 'react-intl-next';

const cache = createIntlCache();

export const getIntl = (config: IntlConfig) => createIntl(config, cache);
